var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"form-wrapper",attrs:{"id":_vm.id}},[_c('div',{staticClass:"form-inner"},[(_vm.formTitle)?_c('div',{staticClass:"form-title"},[_c('h4',[_vm._v(_vm._s(_vm.formTitle))])]):_vm._e(),_c('div',{staticClass:"form-inner-wrapper"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }